'use client'
import React, { memo, useEffect, useState } from 'react'
import { usePathname } from 'next/navigation'
import Image from 'next/image'

export const Social = memo(() => {
  const pathname = usePathname()
  const [location, setLocation] = useState('')
  const [title, setTitle] = useState('')

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setLocation(window.location.href)
      setTitle(document.title)
    }
  }, [pathname])

  const socialLinks = [
    {
      name: 'Facebook',
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        location
      )}`,
      icon: {
        src: '/images/icons/icon-fb.webp',
        srcSet: '/images/icons/icon-fb.webp 1x, /images/icons/icon-fb@2x.webp',
        alt: 'Facebookで共有'
      }
    },
    {
      name: 'X',
      href: `https://twitter.com/share?text=${encodeURIComponent(
        title
      )}&url=${encodeURIComponent(location)}`,
      icon: {
        src: '/images/icons/icon-x.webp',
        srcSet: '/images/icons/icon-x.webp 1x, /images/icons/icon-x@2x.webp',
        alt: 'Xで共有'
      }
    },
    {
      name: 'LINE',
      href: `https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(
        location
      )}`,
      icon: {
        src: '/images/icons/icon-line.webp',
        srcSet:
          '/images/icons/icon-line.webp 1x, /images/icons/icon-line@2x.webp',
        alt: 'LINEで共有'
      }
    },
    {
      name: 'Email',
      href: 'mailto:info@sample.com?subject=件名',
      icon: {
        src: '/images/icons/icon-mail.webp',
        srcSet:
          '/images/icons/icon-mail.webp 1x, /images/icons/icon-mail@2x.webp',
        alt: 'メールで共有'
      }
    }
  ]

  if (!location) {
    return null
  }

  return (
    <div className="flex flex-wrap mt-10 items-center justify-center bg-white py-5 gap-6 lg:gap-4">
      {socialLinks.map((link) => (
        <a
          key={link.name}
          href={link.href}
          className="w-[27px] lg:w-auto transition hover:opacity-80"
          target="_blank"
          rel="nofollow noopener noreferrer"
        >
          <img
            src={link.icon.src}
            srcSet={link.icon.srcSet}
            alt={link.icon.alt}
            className="w-full"
            width={40}
            height={40}
          />
        </a>
      ))}
    </div>
  )
})

Social.displayName = 'Social'
